import React, { Component } from 'react';
import { Link } from 'gatsby';

import Welcome from './header/welcome.js';
import PrimaryNav from './header/primary_nav.js';

import promo_logo from './header/promo.png';
import mobile_promo_logo from './header/promo.png';

import scel_logo from './header/logo.png';

import './style.scss';

class Header extends Component {
    constructor(props) {
        super(props);
        this.actions = props.actions;
    }

    render() {
        return (
            <header>
                <div className="flush-row promo-top">
                    <div className="col-xs-3 lotto-logo">
                        <div className="row">
                            <div className="col-sm-10 col-sm-offset-1">
                                <a
                                    className="scel-logo"
                                    href={'https://www.illinoislottery.com/'}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img
                                        src={scel_logo}
                                        alt="Illinois Lottery"
                                        className="img-responsive center-block"
                                    />
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="hidden-xs col-xs-6 title">
                        <Link to="/">
                            <img
                                src={promo_logo}
                                alt="promotion name"
                                className="hidden-xs img-responsive center-block promo-header-logo"
                            />
                        </Link>
                    </div>
                    <div className="visible-xs col-xs-6 mobile-title">
                        <Link to="/">
                            <img
                                src={mobile_promo_logo}
                                alt="promotion name"
                                className="visible-xs img-responsive center-block promo-header-logo"
                            />
                        </Link>
                    </div>
                    <div className="col-xs-3">
                        <div className="col-xs-10 col-xs-offset-1">
                            <Welcome
                                user={this.props.user}
                                actions={this.actions}
                            />
                        </div>
                    </div>
                    <div className="col-sm-12 primary-nav">
                        <PrimaryNav
                            user={this.props.user}
                            actions={this.actions}
                            menuLinks={this.props.mainMenu}
                        />
                    </div>
                </div>
            </header>
        );
    }
}

export default Header;
